
export const getBackground = (name, ext = 'jpg') => ({ folder: 'backgrounds', name, ext })
export const getServiceIcon = (name, ext = 'svg') => ({ folder: 'services', name, ext, commons: true })
export const getIcon = (name, ext = 'png') => ({ folder: 'icons', name, ext })
export const getVisual = (name, ext = 'png') => ({ folder: 'visuals', name, ext })
